import CELL_DATA_TYPES from '../cell-types.config';

// Blackout channels configurations
const LISTING_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    width: '50%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'code',
        type: CELL_DATA_TYPES.TEXT,
      },
    ],
  },
  {
    id: 'dateStart',
    label: 'Start Date',
    width: '20%',
    align: 'center',
    dataKey: 'dateStart',
    sortable: true,
    type: CELL_DATA_TYPES.DATE,
  },
  {
    id: 'dateEnd',
    label: 'End Date',
    width: '20%',
    align: 'center',
    dataKey: 'dateEnd',
    sortable: true,
    type: CELL_DATA_TYPES.DATE,
  },
];

export default LISTING_COLUMNS;
